import { Location, RouteConfigSingleView } from 'vue-router/types/router.d';

export interface NamedRouteConfig extends RouteConfigSingleView {
  name?: RouteName | undefined;
  children?: NamedRouteConfig[] | undefined;
}

export interface NamedLocation extends Location {
  name: RouteName;
}

export type RouteName =
  'home'
  | 'homeNew'
  | 'login'
  | 'logout'
  | 'register'
  | 'signup'
  | 'ssoLogin'
  | 'ssoVerify'
  | 'registerFromTemplate'
  | 'impersonate'
  | 'profile'
  | 'notificationIndex'
  | 'notificationDetail'
  | 'issueIndex'
  | 'issueEdit'
  | 'issueCreate'
  | 'categoryCreate'
  | 'categoryEdit'
  | 'inspectionCreate'
  | 'inspectionCreateFromTemplate'
  | 'inspectionEdit'
  | 'inspectionDetail'
  | 'inspectionDetailPublic'
  | 'checklistChooseTemplate'
  | 'checklistChooseMethod'
  | 'checklistFileUpload'
  | 'checklistAiPrompt'
  | 'checklistCreate'
  | 'checklistEdit'
  | 'userCreate'
  | 'userEdit'
  | 'groupCreate'
  | 'groupEdit'
  | 'gatewayIndex'
  | 'gatewayEdit'
  | 'scheduleCreate'
  | 'scheduleEdit'
  | 'sensorIndex'
  | 'sensorCreate'
  | 'sensorEdit'
  | 'sensorMeasurements'
  | 'entityItemCreate'
  | 'entityItemEdit'
  | 'entityItemPropertiesEdit'
  | 'roleCreate'
  | 'roleEdit'
  | 'analytics'
  | 'analyticsOverview'
  | 'analyticsNegativeResponses'
  | 'analyticsNegativeResponsesExplain'
  | 'analyticsScores'
  | 'analyticsScoresExplain'
  | 'analyticsOverdueInspections'
  | 'analyticsOverdueInspectionsExplain'
  | 'analyticsSummaryChecklists'
  | 'analyticsSummaryChecklistsDetail'
  | 'analyticsSummaryChecklistsPhotos'
  | 'analyticsSummaryChecklistsExplain'
  | 'analyticsIssues'
  | 'analyticsIssuesExplain'
  | 'subscription'
  | 'subscribe'
  | 'freePlanEnded'
  | 'billingDetails'
  | 'invoices'
  | 'planDetails'
  | 'initiatePasswordReset'
  | 'executePasswordReset'
  | 'setPassword'
  | 'test'
  | 'test-icon'
  | 'forbidden'
  | 'notFound'
  | 'welcomeFromTemplate'
  | 'subscriptionEndedPage'
  | 'noPlanPage'
  | 'welcomePageMobile'
  | 'pastDueNoManageBillingPermission'
  | 'issueExternalResolver'
  | 'entityFolderCreate'
  | 'entityFolderEdit'
  | 'entityTypeCreate'
  | 'entityTypeEdit'
  | 'forms'
  | 'updateApp'
  | 'administration'
  | 'entityItems'
  | 'entityTypeItems'
  | 'sensors'
  | 'inspectionDetailSection'
  | 'analytics-v2'
  | 'analyticsReportCreate'
  | 'analyticsReportEdit'
  | 'analyticsAiChat'
  | 'checkout'
  | 'integrations'
  | 'integrationDetails'
  | 'integrationDetailsOverview'
  | 'integrationDetailsLogs'
  | 'onboarding'
  | 'publicAnalyticsReport'
  | 'approvalIndex'
  | 'courses'
  | 'courseBuilder'
  | 'courseTake'
  | 'courseReport'
  | 'aiPhotoValidationDetail';

export type TeaserRoutes = 'roleIndex' | 'categoryIndex' | 'analytics';

export enum InspectionDetailSections {
  NEGATIVE_ANSWERS = 'negative_answers'
}
